@if(errorImage)
{
<div class="flex flex-col justify-center items-center mb-20 px-4 md:px-0 text-center w-full space-y-10 md:space-y-5">
    <img class="mt-16" [src]="errorImage" alt="error">
    <p class="font-medium font-noto-serif text-3xl text-[var(--dark-teal)]">Looks like you’ve reached a dead end! </p>

    <p class="font-medium text-xl text-[var(--charcoal)]">But don’t worry, let’s get you back on track.</p>


    <button pButton type="button" severity="info" class="w-full md:w-[158px] h-[35px] mt-2" label="Back to Home"
        [routerLink]="['/']">
    </button>

</div>

}